// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__hEmj0","active":"styles_active__l1Tc3","wrapper":"styles_wrapper__pss1-","header":"styles_header__jZgel","close-icon":"styles_close-icon__HWNxf"};